<template>
  <div>
    <v-container grid-list-lg fluid>
      <v-layout row wrap class="align-center mb-2">
        <v-flex lg3 md4 sm6 xs12>
          <v-menu
            v-model="menuStart"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedStartDateFormatted"
                label="Từ ngày giao"
                prepend-icon="fa-calendar-alt"
                readonly
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex lg3 md4 sm6 xs12>
          <v-menu
            v-model="menuEnd"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedEndDateFormatted"
                label="Đến ngày giao"
                prepend-icon="fa-calendar-alt"
                readonly
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex lg2 md4 sm12 xs12>
          <v-btn color="#0088cc" outlined height="40" @click="applyDateFilter">Xem báo cáo</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex v-for="card in summaryCards" :key="card.title" lg3 md6 sm6 xs12>
          <v-card class="shipping-summary-card" height="100%">
            <v-card-title class="subtitle-2 grey--text text--darken-1">{{ card.title }}</v-card-title>
            <v-card-text :class="['headline', 'font-weight-bold', card.color + '--text']">
              <span v-if="card.isCurrency">{{ card.value | currency }}</span>
              <span v-else>{{ card.value | currency('', 0) }}</span>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-2">
        <v-flex lg6 md12 sm12 xs12>
          <v-card height="100%">
            <v-card-text>
              <highcharts :options="paymentTypeChartOptions"></highcharts>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg6 md12 sm12 xs12>
          <v-card height="100%">
            <v-card-text v-if="daily.length > 0">
              <highcharts :options="dailyChartOptions"></highcharts>
            </v-card-text>
            <v-card-text v-else class="d-flex align-center justify-center fill-height grey--text">
              Chưa có dữ liệu theo ngày trong khoảng đã chọn.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-2">
        <v-flex lg12 md12 sm12 xs12>
          <v-card>
            <v-card-title class="subtitle-1 font-weight-bold">Tổng hợp theo kiểu thu tiền ship</v-card-title>
            <v-data-table
              :headers="summaryHeaders"
              :items="byPaymentType"
              :loading="loading"
              hide-default-footer
              :mobile-breakpoint="100"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.Name }}</td>
                  <td class="text-end">{{ item.ReceiptCount | currency('', 0) }}</td>
                  <td class="text-end">{{ item.ShipVN | currency }}</td>
                  <td class="text-end">{{ item.CompanyShipVN | currency }}</td>
                  <td class="text-end font-weight-bold">{{ item.TotalShip | currency }}</td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr class="total-summary-td">
                  <td>TỔNG CỘNG</td>
                  <td class="text-end">{{ summary.ReceiptCount | currency('', 0) }}</td>
                  <td class="text-end">{{ summary.ShipVN | currency }}</td>
                  <td class="text-end">{{ summary.CompanyShipVN | currency }}</td>
                  <td class="text-end">{{ summary.TotalShip | currency }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="mt-2">
        <v-flex lg12 md12 sm12 xs12>
          <v-card>
            <v-card-title class="subtitle-1 font-weight-bold">Chi tiết phiếu đã xuất</v-card-title>
            <v-data-table
              :headers="receiptHeaders"
              :items="receipts"
              :options.sync="pagination"
              :server-items-length="totalRows"
              :footer-props="itemsPerPage"
              :loading="loading"
              :mobile-breakpoint="100"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="font-weight-bold">{{ item.Code }}</td>
                  <td class="text-no-wrap">{{ item.DeliveryDate | display_date('DD-MM-YYYY HH:mm:ss') }}</td>
                  <td>
                    <span class="font-weight-bold blue--text">{{ item.CustomerName || item.Username }}</span>
                    <br>
                    <small>{{ item.UserCode || '' }}</small>
                  </td>
                  <td>{{ item.ShippingMethod || '' }}</td>
                  <td>{{ getPaymentTypeName(item.ShipPaymentType) }}</td>
                  <td class="text-end">{{ item.ShipVN | currency }}</td>
                  <td class="text-end">{{ item.CompanyShipVN | currency }}</td>
                  <td class="text-end font-weight-bold">{{ item.TotalShip | currency }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import { mapState } from 'vuex'
import moment from 'moment'
import configs from '@/configs'

export default {
  name: 'ShippingFeeReport',

  components: {
    highcharts: Chart
  },

  data() {
    return {
      dateRange: {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD')
      },
      menuStart: false,
      menuEnd: false,
      pagination: {
        ...configs.PAGINATION,
        sortBy: ['DeliveryDate'],
        sortDesc: [true]
      },
      itemsPerPage: {
        'items-per-page-options': [20, 30, 40, 50, 100, 200, 500]
      },
      summaryHeaders: [
        { text: 'Kiểu thu tiền ship', value: 'ShipPaymentType', sortable: false },
        { text: 'Số phiếu', value: 'ReceiptCount', align: 'end', sortable: false },
        { text: 'Khách trả', value: 'ShipVN', align: 'end', sortable: false },
        { text: 'Công ty trả', value: 'CompanyShipVN', align: 'end', sortable: false },
        { text: 'Tổng tiền ship', value: 'TotalShip', align: 'end', sortable: false }
      ],
      receiptHeaders: [
        { text: 'Mã phiếu', value: 'ID', sortable: false },
        { text: 'Ngày giao', value: 'DeliveryDate', sortable: false },
        { text: 'Khách hàng', value: 'CustomerName', sortable: false },
        { text: 'Kiểu ship', value: 'ShippingMethod', sortable: false },
        { text: 'Kiểu thu tiền', value: 'ShipPaymentType', sortable: false },
        { text: 'Khách trả', value: 'ShipVN', align: 'end', sortable: false },
        { text: 'Công ty trả', value: 'CompanyShipVN', align: 'end', sortable: false },
        { text: 'Tổng tiền ship', value: 'TotalShip', align: 'end', sortable: false }
      ]
    }
  },

  computed: {
    ...mapState({
      report: state => state.report.shippingFeeReport || {},
      loading: state => state.report.loading
    }),
    reportData() {
      return this.report.data || {}
    },
    receipts() {
      return this.reportData.receipts || []
    },
    totalRows() {
      return Number(this.reportData.total || 0)
    },
    byPaymentType() {
      return this.reportData.by_payment_type || []
    },
    daily() {
      return this.reportData.daily || []
    },
    summary() {
      return {
        ReceiptCount: 0,
        ShipVN: 0,
        CompanyShipVN: 0,
        TotalShip: 0,
        ...(this.report.summary || {})
      }
    },
    summaryCards() {
      return [
        { title: 'Số phiếu đã xuất', value: this.summary.ReceiptCount, color: 'blue', isCurrency: false },
        { title: 'Tiền ship khách trả', value: this.summary.ShipVN, color: 'green', isCurrency: true },
        { title: 'Tiền ship công ty trả', value: this.summary.CompanyShipVN, color: 'orange', isCurrency: true },
        { title: 'Tổng tiền ship', value: this.summary.TotalShip, color: 'deep-purple', isCurrency: true }
      ]
    },
    computedStartDateFormatted() {
      return this.dateRange.startDate ? moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT) : ''
    },
    computedEndDateFormatted() {
      return this.dateRange.endDate ? moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT) : ''
    },
    paymentTypeChartOptions() {
      return {
        chart: { type: 'column' },
        title: { text: 'Tiền ship theo kiểu thu tiền' },
        credits: { enabled: false },
        xAxis: {
          categories: this.byPaymentType.map(item => item.Name)
        },
        yAxis: {
          min: 0,
          title: { text: 'Số tiền (VNĐ)' }
        },
        tooltip: { shared: true, valueSuffix: ' đ' },
        series: [
          { name: 'Khách trả', data: this.byPaymentType.map(item => Number(item.ShipVN || 0)) },
          { name: 'Công ty trả', data: this.byPaymentType.map(item => Number(item.CompanyShipVN || 0)) }
        ]
      }
    },
    dailyChartOptions() {
      return {
        chart: { type: 'line' },
        title: { text: 'Xu hướng tiền ship theo ngày giao' },
        credits: { enabled: false },
        xAxis: {
          categories: this.daily.map(item => moment(item.DeliveryDate).format(configs.SHORT_DATE_FORMAT))
        },
        yAxis: {
          min: 0,
          title: { text: 'Số tiền (VNĐ)' }
        },
        tooltip: { shared: true, valueSuffix: ' đ' },
        series: [
          { name: 'Khách trả', data: this.daily.map(item => Number(item.ShipVN || 0)) },
          { name: 'Công ty trả', data: this.daily.map(item => Number(item.CompanyShipVN || 0)) }
        ]
      }
    }
  },

  watch: {
    pagination: {
      handler() {
        this.loadData()
      },
      deep: true
    }
  },

  mounted() {
    this.loadData()
    this.$root.$emit('REQUEST_ROOT_OPTION', {})
    this.$root.$on('REQUEST_REFRESH_DATA', this.loadData)
  },

  beforeDestroy() {
    this.$root.$off('REQUEST_REFRESH_DATA', this.loadData)
  },

  methods: {
    applyDateFilter() {
      if (!this.dateRange.startDate || !this.dateRange.endDate) {
        window.getApp.$emit('APP_RESOURCE_FAILED', 'Vui lòng chọn đủ từ ngày giao và đến ngày giao.')
        return
      }
      if (moment(this.dateRange.startDate).isAfter(moment(this.dateRange.endDate), 'day')) {
        window.getApp.$emit('APP_RESOURCE_FAILED', 'Từ ngày giao không được lớn hơn đến ngày giao.')
        return
      }
      if (this.pagination.page !== 1) {
        this.pagination = {
          ...this.pagination,
          page: 1
        }
        return
      }
      this.loadData()
    },
    loadData() {
      if (!this.dateRange.startDate || !this.dateRange.endDate) {
        return
      }
      this.$store.dispatch('report/getShippingFeeReport', {
        pagination: this.pagination,
        startTime: moment(this.dateRange.startDate).startOf('day').format(configs.SQL_DATE_FORMAT),
        endTime: moment(this.dateRange.endDate).startOf('day').format(configs.SQL_DATE_FORMAT)
      })
    },
    getPaymentTypeName(value) {
      const item = this.byPaymentType.find(type => Number(type.ShipPaymentType) === Number(value))
      return item ? item.Name : ''
    }
  }
}
</script>

<style scoped>
.shipping-summary-card {
  border-top: 3px solid #0088cc;
}
</style>
